import { APP_VERSION } from '../config.js';
import { escapeHtml } from '../utils/html.js';
import { backButton } from '../components/branding.js';
import { currentUserEmail, renderAppScreen } from '../components/shell.js';

/** "O aplikacji" — about screen. */
export function renderAbout(mount) {
  const email = currentUserEmail() || '—';

  renderAppScreen(mount, {
    active: 'about',
    leading: backButton(),
    contentHtml: `
      <div class="flex flex-1 flex-col py-10">
        <h1 class="text-2xl font-semibold tracking-tight text-neutral-900">O aplikacji</h1>
        <p class="mt-2 text-sm leading-relaxed text-neutral-500">
          SprintSpeak — aplikacja do nauki Angielskiego w IT.</p>

        <dl class="mt-8 divide-y divide-neutral-200/70">
          <div class="flex items-center justify-between py-3">
            <dt class="text-sm text-neutral-500">Wersja</dt>
            <dd class="text-sm font-medium text-neutral-900">${escapeHtml(APP_VERSION || '—')}</dd>
          </div>
          <div class="flex items-center justify-between gap-4 py-3">
            <dt class="text-sm text-neutral-500">Konto</dt>
            <dd class="truncate text-sm font-medium text-neutral-900">${escapeHtml(email)}</dd>
          </div>
        </dl>

        <div class="mt-8 flex flex-col gap-1 text-sm">
          <a href="#/regulamin"
            class="font-medium text-neutral-600 underline underline-offset-2 transition hover:text-neutral-900">Regulamin</a>
          <a href="#/polityka-prywatnosci"
            class="font-medium text-neutral-600 underline underline-offset-2 transition hover:text-neutral-900">Polityka prywatności</a>
        </div>
      </div>`,
  });
}
